import type { ICashbackDetails as IProps } from "./CashbackDetails";
import Cashback from "./CashbackDetails";

export type ICashbackDetails = IProps;

export default Cashback;
